(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = { create: factory };
  if (root && root.document && !root.TodayMerchCustomerAuth) {
    root.TodayMerchCustomerAuth = factory({ window: root });
    if (root.location.pathname === '/apps/todays-studio/customer-auth/callback') {
      root.TodayMerchCustomerAuth.init().then(function (result) {
        var node = root.document.querySelector('[data-customer-auth-callback]');
        if (node) node.textContent = result.callback ? 'Connexion confirmée. Vous pouvez fermer cette fenêtre.' : 'La connexion n’est pas disponible. Fermez cette fenêtre et réessayez.';
      }).catch(function (error) { var node = root.document.querySelector('[data-customer-auth-callback]'); if (node) node.textContent = error.message; });
    }
  }
})(typeof window !== 'undefined' ? window : null, function createCustomerAuth(options) {
  'use strict';
  options = options || {};
  var win = options.window || window;
  var fetcher = options.fetch || win.fetch.bind(win);
  var now = options.now || Date.now;
  var SESSION_KEY = 'tm.customer-auth.session.v1';
  var PKCE_KEY = 'tm.customer-auth.pkce.v1';
  var CONFIG_PATH = '/apps/todays-studio/customer-auth/config';
  var CODE_PATH = '/apps/todays-studio/customer-auth/code';
  var REGISTRATION_PATH = '/apps/todays-studio/customer-auth/registration';
  var views = new Map(), config = null, initializing = null, session = null, refreshing = null;
  var announcedSessionUser = null;
  var pendingSession = null, pendingStage = '', acceptingSession = null;
  var generation = 0, oauthPending = null, sequence = 0;
  var bootstrapRestore = null, bootstrapRequests = new Set();
  var cooldowns = new Map();
  var activeDialog = null;
  var LOGO_URL = 'https://todaymerch.com/cdn/shop/files/SVG_TODAY_MERCH_LOGO.svg?v=1771343473';
  var messages = {
    disabled: 'La connexion n’est pas disponible pour le moment.',
    config_invalid: 'La connexion n’est pas disponible pour le moment.',
    network_error: 'La connexion a été interrompue. Réessayez dans un instant.',
    invalid_email: 'Saisissez une adresse e-mail valide.',
    invalid_code: 'Saisissez le code à 6 chiffres reçu par e-mail.',
    otp_expired: 'Ce code est incorrect ou a expiré. Vérifiez-le ou demandez un nouveau code.',
    invalid_credentials: 'L’adresse e-mail ou le mot de passe est incorrect.',
    weak_password: 'Choisissez un autre mot de passe d’au moins 8 caractères, unique à ce compte. Les mots de passe trop simples ou compromis ne sont pas acceptés.',
    password_compromised: 'Ce mot de passe apparaît dans des fuites de données connues. Choisissez un autre mot de passe, unique à ce compte.',
    same_password: 'Choisissez un mot de passe différent de l’ancien.',
    over_request_rate_limit: 'Trop de tentatives. Patientez un instant avant de réessayer.',
    over_email_send_rate_limit: 'Patientez avant de demander un nouveau code.',
    session_expired: 'Votre session a expiré. Connectez-vous à nouveau.',
    popup_blocked: 'Autorisez la fenêtre de connexion dans votre navigateur, puis réessayez.',
    oauth_cancelled: 'La connexion a été annulée.',
    oauth_invalid: 'La connexion a expiré. Réessayez.',
    storage_unavailable: 'Autorisez le stockage de session du navigateur pour vous connecter.',
    request_failed: 'La connexion n’a pas abouti. Réessayez dans un instant.'
  };
  function fail(code, retryAfter) {
    var error = new Error(messages[code] || messages.request_failed);
    error.code = messages[code] ? code : 'request_failed';
    if (retryAfter) error.retryAfter = retryAfter;
    return error;
  }
  function assertOperation(settings) {
    if (settings && typeof settings.isCurrent === 'function' && !settings.isCurrent()) throw fail('session_expired');
  }
  function passwordWarning(data) {
    if (['weak_password', 'password_compromised'].includes(data?.passwordWarning)) return data.passwordWarning;
    var reasons = data?.weak_password?.reasons;
    if (!Array.isArray(reasons) || !reasons.length || !reasons.every(function (reason) { return typeof reason === 'string'; })) return '';
    return reasons.includes('pwned') ? 'password_compromised' : 'weak_password';
  }
  function passwordErrorCode(code, data) {
    return code === 'weak_password' && passwordWarning(data) === 'password_compromised' ? 'password_compromised' : code;
  }
  function read(key) { try { return JSON.parse(win.sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } }
  function write(key, value) { try { win.sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } }
  function remove(key) { try { win.sessionStorage.removeItem(key); } catch (_) {} }
  function escape(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function email(value) {
    var result = String(value || '').trim().toLowerCase();
    if (result.length > 254 || !/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(result)) throw fail('invalid_email');
    return result;
  }
  function safeReturn(value) {
    var url;
    try { url = new URL(value || '/apps/todays-studio/project?locale=fr#panier', win.location.origin); } catch (_) { return '/apps/todays-studio/project?locale=fr#panier'; }
    if (url.origin !== win.location.origin || !['/apps/todays-studio/project', '/pages/espace-client', '/account'].includes(url.pathname)) return '/apps/todays-studio/project?locale=fr#panier';
    var locale = url.searchParams.get('locale');
    var hash = /^#[a-zA-Z0-9_/-]{0,100}$/.test(url.hash) ? url.hash : '';
    var query = new URLSearchParams();
    if (['fr', 'en'].includes(locale)) query.set('locale', locale);
    var uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[1-8][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i;
    if (url.pathname === '/apps/todays-studio/project' && url.searchParams.getAll('project').length === 1 && uuid.test(url.searchParams.get('project') || '')) {
      query.set('project', url.searchParams.get('project'));
      if (url.searchParams.getAll('quote').length === 1 && uuid.test(url.searchParams.get('quote') || '')) {
        query.set('quote', url.searchParams.get('quote'));
        if (url.searchParams.getAll('download').length === 1 && url.searchParams.get('download') === 'quote') query.set('download', 'quote');
      }
    }
    return url.pathname + (query.size ? '?' + query.toString() : '') + hash;
  }
  function validateConfig(value) {
    if (!value || value.enabled !== true) return { enabled: false };
    var url, redirect;
    try { url = new URL(value.supabaseUrl); redirect = new URL(value.redirectUrl, win.location.origin); } catch (_) { throw fail('config_invalid'); }
    if (url.protocol !== 'https:' || !/^[a-z0-9-]+\.supabase\.co$/.test(url.hostname) || url.port || url.username || url.password || url.search || url.hash || (url.pathname !== '/' && url.pathname !== '')) throw fail('config_invalid');
    if (!/^sb_publishable_[A-Za-z0-9_-]{16,}$/.test(String(value.publishableKey || ''))) throw fail('config_invalid');
    if (redirect.origin !== win.location.origin || redirect.pathname !== '/apps/todays-studio/customer-auth/callback' || redirect.username || redirect.password || redirect.hash || redirect.search) throw fail('config_invalid');
    if (value.methods?.password !== true) throw fail('config_invalid');
    return { enabled: true, supabaseUrl: url.origin, publishableKey: value.publishableKey, redirectUrl: redirect.href, methods: { emailCode: value.methods?.emailCode === true, password: true, google: value.methods?.google === true, microsoft: value.methods?.microsoft === true } };
  }
  function sessionValue(data) {
    var expiresAt = Number(data?.expires_at) * 1000 || now() + Number(data?.expires_in) * 1000;
    if (!data || !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(String(data.access_token || '')) || typeof data.refresh_token !== 'string' || data.refresh_token.length < 8 || !data.user || typeof data.user.id !== 'string' || !Number.isFinite(expiresAt)) throw fail('session_expired');
    var value = { access_token: data.access_token, refresh_token: data.refresh_token, expires_at: expiresAt / 1000, user: { id: data.user.id, email: typeof data.user.email === 'string' ? data.user.email : '' } };
    var warning = passwordWarning(data);
    if (warning) value.passwordWarning = warning;
    return value;
  }
  function storeSession(data, expectedGeneration) {
    if (expectedGeneration !== generation) throw fail('session_expired');
    session = sessionValue(data);
    pendingSession = null; pendingStage = ''; acceptingSession = null;
    write(SESSION_KEY, { origin: config.supabaseUrl, method: 'password', session: session });
    announceSession(session.user.id);
    return publicSession();
  }
  function announceSession(userId) {
    if (announcedSessionUser === userId) return;
    announcedSessionUser = userId;
    if (typeof win.dispatchEvent === 'function' && typeof win.CustomEvent === 'function') {
      win.dispatchEvent(new win.CustomEvent('todaymerch:customer-session-change', { detail: { authenticated: Boolean(userId) } }));
    }
  }
  function publicSession(returnTo) { return session ? Object.assign({ accessToken: session.access_token, expiresAt: session.expires_at * 1000, user: { id: session.user.id, email: session.user.email }, returnTo: safeReturn(returnTo) }, session.passwordWarning ? { passwordWarning: session.passwordWarning } : {}) : null; }
  function clearSession() { generation++; if (oauthPending) oauthPending.cancel(); bootstrapRequests.forEach(function (cancel) { cancel(); }); session = null; pendingSession = null; pendingStage = ''; acceptingSession = null; refreshing = null; remove(SESSION_KEY); remove(PKCE_KEY); announceSession(null); }
  async function registrationRequest(candidate, password) {
    var response, data, timer, controller = typeof win.AbortController === 'function' ? new win.AbortController() : null;
    var deadline = new Promise(function (_, reject) { timer = (win.setTimeout || setTimeout)(function () {
      if (controller) controller.abort();
      reject(fail('network_error'));
    }, 15000); });
    var operation = (async function () {
    try {
      response = await fetcher(REGISTRATION_PATH, { method: password === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store', referrerPolicy: 'no-referrer', ...(controller ? { signal: controller.signal } : {}), headers: Object.assign({ Accept: 'application/json', Authorization: 'Bearer ' + candidate.access_token }, password === undefined ? {} : { 'Content-Type': 'application/json' }), body: password === undefined ? undefined : JSON.stringify({ password: password }) });
    } catch (_) { throw fail('network_error'); }
    try { data = await response.json(); } catch (_) { throw fail('request_failed'); }
    if (!response.ok) {
      var code = data.error?.code || data.error || data.code;
      if (response.status === 401) code = 'session_expired';
      if (response.status === 429) code = 'over_request_rate_limit';
      throw fail(passwordErrorCode(code, data.error?.weak_password ? data.error : data));
    }
    if (typeof data.passwordRequired !== 'boolean') throw fail('request_failed');
    return data;
    })();
    try { return await Promise.race([operation, deadline]); }
    finally { (win.clearTimeout || clearTimeout)(timer); }
  }
  async function acceptSession(data, expectedGeneration, returnTo, requirePassword, inspected, settings) {
    assertOperation(settings);
    if (expectedGeneration !== generation) throw fail('session_expired');
    var candidate = sessionValue(data);
    if (announcedSessionUser && announcedSessionUser !== candidate.user.id) announceSession(null);
    session = null; pendingSession = null; pendingStage = ''; acceptingSession = candidate; remove(SESSION_KEY);
    try {
      var inspection = inspected && inspected.token === candidate.access_token && inspected.generation === expectedGeneration
        ? await inspected.result : null;
      if (inspection?.error) throw inspection.error;
      var registration = inspection ? inspection.value : await registrationRequest(candidate);
      assertOperation(settings);
      if (generation !== expectedGeneration || acceptingSession !== candidate) throw fail('session_expired');
      acceptingSession = null;
      if (registration.passwordRequired || requirePassword) {
        pendingSession = candidate;
        pendingStage = registration.passwordRequired ? 'registration' : 'new-password';
        return { passwordRequired: true, email: candidate.user.email };
      }
      storeSession(candidate, expectedGeneration);
      return publicSession(returnTo);
    } catch (error) { if (acceptingSession === candidate) acceptingSession = null; throw error; }
  }
  async function completeRegistration(password, settings) {
    await enabled('password');
    assertOperation(settings);
    if (typeof password !== 'string' || password.length < 8 || password.length > 1024) throw fail('weak_password');
    var candidate = pendingSession, epoch = generation;
    if (!candidate || pendingStage !== 'registration') throw fail('session_expired');
    var registration = await registrationRequest(candidate, password);
    assertOperation(settings);
    if (registration.passwordRequired) throw fail('request_failed');
    if (epoch !== generation || pendingSession !== candidate) throw fail('session_expired');
    return confirmPasswordSession(candidate, password, epoch, settings);
  }
  async function confirmPasswordSession(candidate, password, epoch, settings) {
    var data = await request('/token?grant_type=password', { email: email(candidate.user.email), password: password });
    assertOperation(settings);
    if (epoch !== generation || pendingSession !== candidate) throw fail('session_expired');
    var verified = sessionValue(data);
    if (verified.user.id !== candidate.user.id || email(verified.user.email) !== email(candidate.user.email)) throw fail('session_expired');
    return storeSession(verified, epoch);
  }
  async function request(path, body, accessToken, method) {
    var response;
    try {
      response = await fetcher(config.supabaseUrl + '/auth/v1' + path, { method: method || 'POST', credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', headers: Object.assign({ apikey: config.publishableKey, 'Content-Type': 'application/json' }, accessToken ? { Authorization: 'Bearer ' + accessToken } : {}), body: body === undefined ? undefined : JSON.stringify(body) });
    } catch (_) { throw fail('network_error'); }
    var data = {};
    if (response.status !== 204) { try { data = await response.json(); } catch (_) { if (response.ok) throw fail('request_failed'); } }
    if (!response.ok) {
      var code = data.error_code || data.code;
      if (response.status === 429 && !messages[code]) code = 'over_request_rate_limit';
      if (response.status === 401 && !messages[code]) code = 'session_expired';
      var retryAfter = Math.min(3600, Math.max(0, Number(response.headers?.get('retry-after')) || 0));
      throw fail(passwordErrorCode(code, data), retryAfter);
    }
    return data;
  }
  function cleanCallbackUrl() {
    var url = new URL(win.location.href), changed = false;
    ['code', 'error', 'error_code', 'error_description', 'access_token', 'refresh_token', 'id_token', 'token_type', 'expires_in'].forEach(function (key) { if (url.searchParams.has(key)) { url.searchParams.delete(key); changed = true; } });
    if (/(?:^#|&)(?:access_token|refresh_token|id_token|error)=/.test(url.hash)) { url.hash = ''; changed = true; }
    if (changed) win.history.replaceState(win.history.state, '', url.pathname + url.search + url.hash);
  }
  async function callback() {
    var url = new URL(win.location.href), code = url.searchParams.get('code'), oauthError = url.searchParams.has('error');
    if (!code && !oauthError) { cleanCallbackUrl(); return false; }
    cleanCallbackUrl();
    var pending = read(PKCE_KEY);
    if (!pending || pending.origin !== config.supabaseUrl || now() - pending.createdAt > 10 * 60 * 1000 || now() < pending.createdAt || url.pathname !== new URL(config.redirectUrl).pathname || !/^[A-Za-z0-9_-]{20,}$/.test(pending.nonce || '')) { remove(PKCE_KEY); throw fail('oauth_invalid'); }
    if (win.opener && !win.opener.closed) {
      win.opener.postMessage({ type: 'todaymerch:oauth-code', code: oauthError ? '' : code, error: oauthError, nonce: pending.nonce }, win.location.origin);
      remove(PKCE_KEY);
      win.close();
      return true;
    }
    remove(PKCE_KEY);
    throw fail('oauth_invalid');
  }
  async function init() {
    if (initializing) return initializing;
    var restore = { pending: true, resolve: null, ready: null };
    restore.ready = new Promise(function (resolve) { restore.resolve = resolve; });
    bootstrapRestore = restore;
    initializing = (async function () {
      var saved = read(SESSION_KEY), restoreGeneration = generation, inspected = null;
      // The saved origin never controls this request destination. Verify only
      // with our same-origin registration endpoint, then await current config
      // before accepting the session or exposing any credentials.
      if (saved?.method === 'password' && /^https:\/\/[a-z0-9-]+\.supabase\.co$/.test(saved.origin || '')) {
        try {
          var savedCandidate = sessionValue(saved.session);
          if (savedCandidate.expires_at * 1000 > now() + 60000) {
            inspected = { token: savedCandidate.access_token, generation: restoreGeneration,
              result: registrationRequest(savedCandidate).then(function (value) { return { value: value }; }, function (error) { return { error: error }; }) };
          }
        } catch (_) { /* malformed saved credentials retain the normal cleanup */ }
      }
      var response, data, configTimer;
      var configController = typeof win.AbortController === 'function' ? new win.AbortController() : null;
      var configDeadline = new Promise(function (_, reject) { configTimer = (win.setTimeout || setTimeout)(function () {
        if (configController) configController.abort();
        reject(fail('network_error'));
      }, 10000); });
      var configRequest = (async function () {
        try { response = await fetcher(CONFIG_PATH, { method: 'GET', credentials: 'same-origin', cache: 'no-store', ...(configController ? { signal: configController.signal } : {}), headers: { Accept: 'application/json' } }); } catch (_) { throw fail('network_error'); }
        if (!response.ok) throw fail('config_invalid');
        try { return await response.json(); } catch (_) { throw fail('config_invalid'); }
      })();
      try { data = await Promise.race([configRequest, configDeadline]); }
      finally { (win.clearTimeout || clearTimeout)(configTimer); }
      config = validateConfig(data);
      if (!config.enabled) { clearSession(); cleanCallbackUrl(); return config; }
      if (saved?.origin === config.supabaseUrl && saved.method === 'password') {
        var epoch = restoreGeneration;
        try {
          if (generation !== epoch) throw fail('session_expired');
          var candidate = sessionValue(saved.session);
          remove(SESSION_KEY);
          if (candidate.expires_at * 1000 > now() + 60000) {
            restore.resolve({ candidate: candidate, generation: epoch, origin: config.supabaseUrl });
          }
          if (candidate.expires_at * 1000 <= now() + 60000) candidate = await request('/token?grant_type=refresh_token', { refresh_token: candidate.refresh_token });
          var restored = await acceptSession(candidate, epoch, undefined, undefined, inspected);
          if (restored?.passwordRequired === true && generation === epoch) restore.rejectedSession = pendingSession;
        } catch (_) { if (generation === epoch) clearSession(); }
      }
      else remove(SESSION_KEY);
      if (await callback()) return { enabled: true, callback: true, methods: config.methods };
      return { enabled: true, methods: config.methods };
    })();
    try { return await initializing; } catch (error) { initializing = null; throw error; }
    finally { restore.pending = false; restore.resolve(null); if (bootstrapRestore === restore) bootstrapRestore = null; }
  }
  async function readProjectBootstrap(projectId) {
    if (typeof projectId !== 'string' || !/^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(projectId)) throw fail('request_failed');
    var origin = win.location.origin;
    var initialization = init(), restore = bootstrapRestore;
    // This method never releases the saved credential. Only the fixed owner
    // endpoint may use it while registration is pending.
    var accepted = initialization.then(function () { return null; }, function (error) { return error; });
    if (!restore?.pending) { var completedError = await accepted; if (completedError) throw completedError; return null; }
    var context = await restore.ready;
    if (!context) { var initError = await accepted; if (initError) throw initError; return null; }
    var candidate = context.candidate;
    function isCurrent() {
      return win.location.origin === origin && generation === context.generation && config?.enabled === true && config.supabaseUrl === context.origin
        && session?.access_token === candidate.access_token && session.expires_at * 1000 > now() + 60000;
    }
    if (win.location.origin !== origin || generation !== context.generation || config?.enabled !== true || config.supabaseUrl !== context.origin || candidate.expires_at * 1000 <= now() + 60000) throw fail('session_expired');
    var controller = typeof win.AbortController === 'function' ? new win.AbortController() : null;
    var timer, cancel;
    var cancelled = new Promise(function (_, reject) {
      cancel = function () { if (controller) controller.abort(); reject(fail('session_expired')); };
      timer = (win.setTimeout || setTimeout)(function () { if (controller) controller.abort(); reject(fail('network_error')); }, 20000);
    });
    bootstrapRequests.add(cancel);
    var operation = (async function () {
      var response, data;
      try {
        response = await fetcher(new URL('/apps/todays-studio/project-api/project-bootstrap?projectId=' + encodeURIComponent(projectId), origin).href, {
          method: 'GET', credentials: 'same-origin', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer',
          ...(controller ? { signal: controller.signal } : {}), headers: { Accept: 'application/json', Authorization: 'Bearer ' + candidate.access_token }
        });
      } catch (_) { throw fail('network_error'); }
      try { data = await response.json(); } catch (_) { throw fail('request_failed'); }
      return { ok: response.ok, status: response.status, headers: response.headers, json: async function () { if (!isCurrent()) throw fail('session_expired'); return data; } };
    })();
    try {
      var verified = accepted.then(function (error) {
        if (error) throw error;
        if (!isCurrent()) {
          var rejectedSession = restore.rejectedSession;
          function isCurrentRegistrationRejection() {
            return Boolean(rejectedSession && pendingSession === rejectedSession && !session && !acceptingSession
              && ['registration', 'new-password'].includes(pendingStage)
              && generation === context.generation && win.location.origin === origin
              && config?.enabled === true && config.supabaseUrl === context.origin
              && rejectedSession.access_token === candidate.access_token);
          }
          var refusal = fail('session_expired');
          if (isCurrentRegistrationRejection()) refusal.isCurrentRegistrationRejection = isCurrentRegistrationRejection;
          throw refusal;
        }
      });
      var values = await Promise.race([Promise.all([operation, verified]), cancelled]);
      if (!isCurrent()) throw fail('session_expired');
      return { response: values[0], isCurrent: isCurrent };
    } catch (error) { if (controller) controller.abort(); throw error; }
    finally { bootstrapRequests.delete(cancel); (win.clearTimeout || clearTimeout)(timer); }
  }
  async function enabled(method) {
    await init();
    if (!config?.enabled || (method && !config.methods[method])) throw fail('disabled');
  }
  async function getAccessToken() {
    await init();
    if (!config?.enabled) return null;
    if (refreshing) return refreshing;
    if (!session) return null;
    if (session.expires_at * 1000 > now() + 60000) return session.access_token;
    var epoch = generation, previous = session;
    var pending = (async function () {
      try {
        var data = await request('/token?grant_type=refresh_token', { refresh_token: previous.refresh_token });
        if (previous.passwordWarning && !passwordWarning(data)) data = Object.assign({}, data, { passwordWarning: previous.passwordWarning });
        var accepted = await acceptSession(data, epoch);
        return accepted.accessToken || null;
      } catch (error) {
        if (generation === epoch) clearSession();
        return null;
      } finally { if (refreshing === pending) refreshing = null; }
    })();
    refreshing = pending;
    return pending;
  }
  async function sendEmailCode(address, settings) {
    await enabled('emailCode');
    assertOperation(settings);
    var normalized = email(address), until = cooldowns.get(normalized) || 0;
    if (until > now()) throw fail('over_email_send_rate_limit', Math.ceil((until - now()) / 1000));
    var result;
    try {
      var response;
      try { response = await fetcher(CODE_PATH, { method: 'POST', credentials: 'same-origin', cache: 'no-store', referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ email: normalized }) }); } catch (_) { throw fail('network_error'); }
      try { result = await response.json(); } catch (_) { throw fail('request_failed'); }
      if (!response.ok || result.sent !== true) throw fail(response.status === 429 ? 'over_email_send_rate_limit' : (result.error?.code || result.error || result.code), Math.min(3600, Math.max(0, Number(result.retryAfter || response.headers?.get('retry-after')) || 0)));
    }
    catch (error) { if (error.retryAfter || error.code === 'over_email_send_rate_limit' || error.code === 'over_request_rate_limit') cooldowns.set(normalized, now() + (error.retryAfter || 60) * 1000); throw error; }
    cooldowns.set(normalized, now() + Math.min(3600, Math.max(60, Number(result.retryAfter) || 60)) * 1000);
    return { sent: true, email: normalized, retryAt: cooldowns.get(normalized) };
  }
  async function verifyEmailCode(address, code, settings) {
    await enabled('emailCode');
    assertOperation(settings);
    var normalized = email(address), token = String(code || '').replace(/\s/g, '');
    if (!/^\d{6}$/.test(token)) throw fail('invalid_code');
    var epoch = generation;
    // Only the verified server registration state decides whether this account
    // still needs a password. Recovery is a separate, explicit user choice.
    return acceptSession(await request('/verify', { email: normalized, token: token, type: 'email' }), epoch, undefined, settings?.recovery === true, undefined, settings);
  }
  async function signInWithPassword(address, password, settings) {
    await enabled('password');
    assertOperation(settings);
    if (typeof password !== 'string' || !password || password.length > 1024) throw fail('invalid_credentials');
    var epoch = generation;
    return acceptSession(await request('/token?grant_type=password', { email: email(address), password: password }), epoch, undefined, undefined, undefined, settings);
  }
  async function updatePassword(password, settings) {
    await enabled('password');
    assertOperation(settings);
    if (typeof password !== 'string' || password.length < 8 || password.length > 1024) throw fail('weak_password');
    var candidate = pendingStage === 'new-password' ? pendingSession : null, epoch = generation;
    var token = candidate ? candidate.access_token : await getAccessToken();
    if (!token) throw fail('session_expired');
    try { await request('/user', { password: password }, token, 'PUT'); }
    catch (error) {
      // A successful save may have been followed by an interrupted password
      // exchange. Verify the submitted password again before exposing a session.
      if (!candidate || error.code !== 'same_password') throw error;
    }
    assertOperation(settings);
    if (candidate) {
      if (epoch !== generation || pendingSession !== candidate) throw fail('session_expired');
      return confirmPasswordSession(candidate, password, epoch, settings);
    }
    if (epoch !== generation || !session || session.access_token !== token) throw fail('session_expired');
    delete session.passwordWarning;
    write(SESSION_KEY, { origin: config.supabaseUrl, method: 'password', session: session });
    return publicSession();
  }
  function random(size) { var bytes = new Uint8Array(size); win.crypto.getRandomValues(bytes); return base64url(bytes); }
  function base64url(bytes) { return win.btoa(String.fromCharCode.apply(null, bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function signInWithProvider(provider, settings) {
    if (!['google', 'microsoft'].includes(provider) || !config?.enabled || !config.methods[provider]) return Promise.reject(fail('disabled'));
    try { assertOperation(settings); } catch (error) { return Promise.reject(error); }
    if (oauthPending) return oauthPending.provider === provider ? oauthPending.promise : Promise.reject(fail('request_failed'));
    var popup = win.open('about:blank', 'TodayMerchSignIn' + now(), 'popup,width=520,height=680');
    if (!popup) return Promise.reject(fail('popup_blocked'));
    var epoch = generation, settled = false, interval, exchangeTimer, listener, resolver, rejecter;
    var promise = new Promise(function (resolve, reject) { resolver = resolve; rejecter = reject; });
    function finish(error, value) {
      if (settled) return;
      settled = true; win.clearInterval(interval); (win.clearTimeout || clearTimeout)(exchangeTimer); if (listener) win.removeEventListener('message', listener); remove(PKCE_KEY);
      try { popup.close(); } catch (_) {}
      oauthPending = null;
      if (error) rejecter(error); else resolver(value);
    }
    oauthPending = { promise: promise, provider: provider, owner: settings?.view, cancel: function () { finish(fail('oauth_cancelled')); } };
    var operation = { isCurrent: function () { return !settled && generation === epoch && (typeof settings?.isCurrent !== 'function' || settings.isCurrent()); } };
    (async function () {
      try {
        if (!win.crypto?.subtle) throw fail('oauth_invalid');
        var verifier = random(48), nonce = random(24), challenge = base64url(new Uint8Array(await win.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))));
        if (settled || generation !== epoch) return;
        assertOperation(operation);
        var pending = { verifier: verifier, nonce: nonce, createdAt: now(), origin: config.supabaseUrl, returnTo: safeReturn(settings?.returnTo) };
        if (!write(PKCE_KEY, pending)) throw fail('storage_unavailable');
        // The popup starts on our origin; its own session storage survives OAuth navigation.
        popup.sessionStorage.setItem(PKCE_KEY, JSON.stringify({ nonce: nonce, createdAt: pending.createdAt, origin: pending.origin }));
        var url = new URL(config.supabaseUrl + '/auth/v1/authorize');
        url.searchParams.set('provider', provider === 'microsoft' ? 'azure' : 'google'); url.searchParams.set('redirect_to', config.redirectUrl); url.searchParams.set('code_challenge', challenge); url.searchParams.set('code_challenge_method', 's256');
        if (provider === 'microsoft') url.searchParams.set('scopes', 'email');
        listener = async function (event) {
          var data = event.data;
          if (settled || event.origin !== win.location.origin || event.source !== popup || !data || data.type !== 'todaymerch:oauth-code' || data.nonce !== nonce) return;
          if (data.error || !/^[A-Za-z0-9_-]{12,512}$/.test(data.code || '')) return finish(fail('oauth_invalid'));
          win.removeEventListener('message', listener); win.clearInterval(interval);
          exchangeTimer = (win.setTimeout || setTimeout)(function () { finish(fail('network_error')); }, 15000);
          try { finish(null, await acceptSession(await request('/token?grant_type=pkce', { auth_code: data.code, code_verifier: verifier }), epoch, pending.returnTo, undefined, undefined, operation)); } catch (error) { finish(error); }
        };
        win.addEventListener('message', listener);
        popup.location.replace(url.href);
        interval = win.setInterval(function () { if (popup.closed) finish(fail('oauth_cancelled')); else if (now() - pending.createdAt > 10 * 60 * 1000) finish(fail('oauth_invalid')); }, 500);
      } catch (error) { finish(error.code ? error : fail('oauth_invalid')); }
    })();
    return promise;
  }
  function signInWithGoogle(settings) { return signInWithProvider('google', settings); }
  function signInWithMicrosoft(settings) { return signInWithProvider('microsoft', settings); }
  function invalidate() {
    clearSession();
    views.forEach(function (view) { view.stage = 'email'; view.recovery = false; view.notice = ''; view.error = ''; view.warningDismissed = false; render(view); });
  }
  async function logout() {
    var token = session?.access_token || pendingSession?.access_token;
    invalidate();
    if (token && config?.enabled) { try { await request('/logout?scope=local', undefined, token); } catch (_) {} }
    return { signedOut: true };
  }
  async function notify(view) {
    if (views.get(view.container) !== view) return;
    assertOperation(view.options);
    if (pendingSession) { view.stage = pendingStage; view.email = pendingSession.user.email; render(view); return; }
    if (!session) return;
    if (session.passwordWarning && !view.warningDismissed) { view.stage = 'password-warning'; view.error = ''; render(view); return; }
    if (view.options.showSuccess === false && typeof view.options.onAuthenticated === 'function') {
      await view.options.onAuthenticated(publicSession(view.options.returnTo));
      return;
    }
    view.stage = 'done'; view.error = ''; render(view);
    if (typeof view.options.onAuthenticated === 'function') view.options.onAuthenticated(publicSession(view.options.returnTo));
  }
  function report(view, error) {
    if (views.get(view.container) !== view) return;
    view.error = error.message || messages.request_failed;
    if (typeof view.options.onError === 'function') view.options.onError({ code: error.code || 'request_failed', message: view.error });
  }
  function button(label, action, cls) { return '<button type="button" class="tm-auth__button ' + (cls || '') + '" data-auth-action="' + action + '">' + label + '</button>'; }
  function socialMethods() {
    var buttons = '';
    if (config.methods.google) buttons += '<button type="button" class="tm-auth__button tm-auth__social-button tm-auth__social-card" data-auth-action="google" aria-label="Continuer avec Google" title="Continuer avec Google"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 533.5 544.3" width="24" height="24" aria-hidden="true" focusable="false"><path fill="#4285F4" d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.5-54.9 82.7v68h87.7c51.3-47.3 81.6-117 81.6-200.2z"/><path fill="#34A853" d="M272.1 544.3c73.4 0 135-24.1 179.8-65.7l-87.7-68c-24.4 16.3-55.6 25.8-92.1 25.8-70.9 0-131-47.9-152.5-112.3H29.1v70.1c46.2 91.9 141.1 150.1 243 150.1z"/><path fill="#FBBC04" d="M119.6 324.1c-5.4-16.3-8.5-33.7-8.5-51.6s3.1-35.3 8.5-51.6v-70.1H29.1C10.5 187.7 0 229.2 0 272.5s10.5 84.8 29.1 121.7l90.5-70.1z"/><path fill="#EA4335" d="M272.1 108.6c39.9-.6 78.4 14.4 107.5 41.7l80.2-80.2C409 22.6 341.9-3.5 272.1.1 169.1.1 74.2 58.3 29.1 153.7l90.5 70.1c21.4-64.4 81.6-115.2 152.5-115.2z"/></svg></button>';
    if (config.methods.microsoft) buttons += button('Continuer avec Microsoft', 'microsoft', 'tm-auth__social-button');
    return buttons ? '<div class="tm-auth__separator"><span>ou</span></div><div class="tm-auth__social" role="group" aria-label="Autres méthodes de connexion">' + buttons + '</div>' : '';
  }
  function field(view, name, label, type, attrs) {
    var id = view.id + '-' + name;
    var input = '<input id="' + id + '" name="' + name + '" type="' + type + '" ' + attrs + ' required>';
    if (type === 'password') return '<div class="tm-auth__field"><label for="' + id + '">' + label + '</label><div class="tm-auth__password">' + input + '<button type="button" class="tm-auth__password-toggle" data-auth-action="toggle-password" aria-label="Afficher le mot de passe" aria-controls="' + id + '" aria-pressed="false"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg></button></div></div>';
    return '<label class="tm-auth__field" for="' + id + '"><span>' + label + '</span>' + input + '</label>';
  }
  function render(view, focus) {
    if (views.get(view.container) !== view) return;
    var body = '', title = 'Connexion ou inscription', subtitle = '', emailField = field(view, 'email', 'Adresse e-mail', 'email', 'autocomplete="email" inputmode="email" maxlength="254" placeholder="Adresse e-mail" value="' + escape(view.email) + '"');
    if (view.stage === 'done') { title = 'Vous êtes connecté'; subtitle = 'Votre compte est prêt.'; }
    else if (view.stage === 'password-warning') {
      title = 'Protégez votre compte'; subtitle = 'Vous êtes connecté. Nous vous recommandons de changer votre mot de passe.';
      body = '<p role="status">' + escape(messages[session?.passwordWarning] || messages.weak_password) + '</p>' + button('Changer mon mot de passe', 'change-password', 'tm-auth__button--primary') + button('Continuer pour le moment', 'continue', 'tm-auth__link');
    } else if (view.stage === 'change-password') {
      title = 'Changez votre mot de passe'; subtitle = 'Votre connexion reste active pendant cette mise à jour.';
      body = field(view, 'password', 'Nouveau mot de passe', 'password', 'autocomplete="new-password" minlength="8" maxlength="1024"') + '<p class="tm-auth__hint">Au moins 8 caractères. Utilisez un mot de passe unique à ce compte.</p><button type="submit" class="tm-auth__button tm-auth__button--primary">Enregistrer mon mot de passe</button>' + button('Continuer pour le moment', 'continue', 'tm-auth__link');
    }
    else if (view.stage === 'code') {
      title = 'Confirmez qu’il s’agit bien de vous'; subtitle = 'Nous avons envoyé un code à l’adresse ' + escape(view.email) + '.';
      body = field(view, 'code', 'Code à 6 chiffres', 'text', 'autocomplete="one-time-code" inputmode="numeric" pattern="[0-9]{6}" maxlength="6" placeholder="------" class="tm-auth__code"') + '<div class="tm-auth__resend"><span>Vous ne l’avez pas reçu ?</span>' + button('Envoyer un nouveau code', 'resend', 'tm-auth__link') + '</div>' + (view.options.dialog ? '' : button('Modifier l’e-mail', 'email', 'tm-auth__link'));
    } else if (view.stage === 'password') {
      title = 'Connectez-vous avec votre mot de passe';
      body = emailField + field(view, 'password', 'Mot de passe', 'password', 'autocomplete="current-password" maxlength="1024"') + (config.methods.emailCode ? '<div class="tm-auth__recovery">' + button('Mot de passe oublié ?', 'recovery', 'tm-auth__link') + '</div>' : '') + '<button type="submit" class="tm-auth__button tm-auth__button--primary">Se connecter</button>' + button('Recevoir un code par e-mail', 'email', 'tm-auth__link');
    } else if (view.stage === 'registration') {
      title = 'Créez votre compte'; subtitle = 'Votre e-mail est vérifié. Choisissez un mot de passe pour créer votre compte Today Merch.';
      body = field(view, 'password', 'Mot de passe', 'password', 'autocomplete="new-password" minlength="8" maxlength="1024"') + '<p class="tm-auth__hint">8 caractères minimum.</p><button type="submit" class="tm-auth__button tm-auth__button--primary">Créer mon compte</button>' + button('Modifier l’e-mail', 'cancel-registration', 'tm-auth__link');
    } else if (view.stage === 'new-password') {
      title = 'Choisissez un mot de passe'; subtitle = 'Votre e-mail est vérifié. Enregistrez votre mot de passe pour vous connecter.';
      body = field(view, 'password', 'Nouveau mot de passe', 'password', 'autocomplete="new-password" minlength="8" maxlength="1024"') + '<p class="tm-auth__hint">8 caractères minimum.</p><button type="submit" class="tm-auth__button tm-auth__button--primary">Enregistrer et se connecter</button>' + button('Revenir à la connexion', 'cancel-registration', 'tm-auth__link');
    } else {
      if (view.recovery) { title = 'Retrouvez votre compte'; subtitle = 'Un code par e-mail vous permettra de choisir un nouveau mot de passe.'; }
      body = emailField + '<button type="submit" class="tm-auth__button tm-auth__button--primary">' + (view.recovery ? 'Recevoir mon code' : 'Continuer') + '</button>';
      if (!view.recovery) body += button('Essayer une autre méthode', 'password', 'tm-auth__alternative') + socialMethods();
    }
    var back = view.options.dialog && view.stage !== 'email' && view.stage !== 'done' ? '<button type="button" class="tm-auth__back" data-auth-action="back" aria-label="Retour"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m14 5-7 7 7 7"/></svg></button>' : '';
    view.container.innerHTML = '<section class="tm-auth" data-auth-stage="' + view.stage + '" aria-labelledby="' + view.id + '-title">' + back + '<img class="tm-auth__logo" src="' + LOGO_URL + '" alt="Today Merch" width="120" height="42"><h2 id="' + view.id + '-title">' + title + '</h2><p class="tm-auth__intro"' + (subtitle ? '' : ' hidden') + '>' + subtitle + '</p><form class="tm-auth__form" novalidate aria-busy="' + String(view.busy) + '">' + body + '<p class="tm-auth__error" role="alert"' + (view.error ? '' : ' hidden') + '>' + escape(view.error) + '</p><p class="tm-auth__notice" role="status"' + (view.notice ? '' : ' hidden') + '>' + escape(view.notice) + '</p></form></section>';
    updateBusy(view);
    updateCooldown(view);
    if (focus) view.container.querySelector('[name="' + focus + '"]')?.focus();
  }
  function updateBusy(view) {
    if (views.get(view.container) !== view) return;
    var form = view.container.querySelector('form'), submitButton = form?.querySelector('button[type="submit"]');
    form?.setAttribute('aria-busy', String(view.busy));
    view.container.querySelectorAll('button,input').forEach(function (node) { node.disabled = view.busy; });
    if (view.busy) {
      if (submitButton) submitButton.setAttribute('aria-busy', 'true');
      if (submitButton && view.stage === 'password') submitButton.textContent = 'Connexion…';
      if (!view.container.querySelector('.tm-auth__loading-status')) {
        var status = win.document.createElement('span');
        status.className = 'tm-auth__loading-status'; status.setAttribute('role', 'status');
        status.textContent = view.stage === 'password' ? 'Connexion en cours…' : view.stage === 'code' ? 'Vérification du code…' : 'Veuillez patienter…';
        view.container.querySelector('.tm-auth')?.append(status);
      }
    }
    if (view.busy) view.container.querySelectorAll('.tm-auth__error, .tm-auth__notice').forEach(function (node) { node.hidden = true; });
  }
  function updateCooldown(view) {
    var node = view.container.querySelector('[data-auth-action="resend"]');
    if (!node) return;
    var seconds = Math.max(0, Math.ceil(((cooldowns.get(view.email) || 0) - now()) / 1000));
    node.disabled = view.busy || seconds > 0;
    node.textContent = seconds ? 'Renvoyer dans ' + seconds + ' s' : 'Envoyer un nouveau code';
  }
  async function perform(view, operation) {
    if (view.busy) return;
    view.busy = true; view.error = ''; view.notice = ''; updateBusy(view);
    try { await operation(); } catch (error) { report(view, error); }
    finally { view.busy = false; render(view, view.stage === 'code' ? 'code' : null); }
  }
  async function submit(view, event) {
    event.preventDefault();
    var form = event.target, address = form.querySelector('[name="email"]')?.value, password = form.querySelector('[name="password"]')?.value, code = form.querySelector('[name="code"]')?.value;
    if (address !== undefined) view.email = address;
    var settings = { recovery: view.recovery, isCurrent: function () { return views.get(view.container) === view && (typeof view.options.isCurrent !== 'function' || view.options.isCurrent()); } };
    if (['code', 'password', 'registration', 'new-password', 'change-password'].includes(view.stage)) view.hasAuthenticationAttempt = true;
    await perform(view, async function () {
      if (view.stage === 'code') { await verifyEmailCode(view.email, code, settings); await notify(view); }
      else if (view.stage === 'password') { await signInWithPassword(view.email, password, settings); await notify(view); }
      else if (view.stage === 'registration') { await completeRegistration(password, settings); await notify(view); }
      else if (view.stage === 'new-password' || view.stage === 'change-password') { await updatePassword(password, settings); await notify(view); }
      else { var result = await sendEmailCode(view.email, settings); assertOperation(settings); view.email = result.email; view.stage = 'code'; }
    });
  }
  function click(view, event) {
    var target = event.target.closest('[data-auth-action]');
    if (!target || !view.container.contains(target) || view.busy) return;
    var action = target.dataset.authAction;
    if (action === 'back') {
      if (pendingSession) { invalidate(); return; }
      view.stage = 'email'; view.recovery = false; view.error = ''; view.notice = ''; render(view, 'email'); return;
    }
    if (action === 'change-password' && session) { view.stage = 'change-password'; view.error = ''; view.notice = ''; render(view, 'password'); return; }
    if (action === 'continue' && session) { view.warningDismissed = true; return perform(view, function () { return notify(view); }); }
    if (action === 'toggle-password') {
      var passwordInput = view.container.querySelector('[name="password"]');
      if (!passwordInput) return;
      var visible = passwordInput.type === 'password';
      passwordInput.type = visible ? 'text' : 'password';
      target.setAttribute('aria-pressed', String(visible));
      target.setAttribute('aria-label', visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
      return;
    }
    if (action === 'cancel-registration') { invalidate(); return; }
    if (pendingSession) { notify(view); return; }
    var input = view.container.querySelector('[name="email"]'); if (input) view.email = input.value;
    if (['google', 'microsoft'].includes(action)) {
      view.hasAuthenticationAttempt = true;
      var settings = { view: view, returnTo: view.options.returnTo, isCurrent: function () { return views.get(view.container) === view && (typeof view.options.isCurrent !== 'function' || view.options.isCurrent()); } };
      return perform(view, async function () { await signInWithProvider(action, settings); await notify(view); });
    }
    if (action === 'resend') return perform(view, async function () { await sendEmailCode(view.email, { recovery: view.recovery }); view.notice = 'Un nouveau code vient d’être envoyé.'; });
    if (!['password', 'email', 'signup', 'recovery'].includes(action)) return;
    view.error = ''; view.notice = '';
    view.recovery = action === 'recovery';
    view.stage = action === 'password' ? 'password' : view.recovery && (cooldowns.get(view.email) || 0) > now() ? 'code' : 'email';
    render(view, view.stage === 'code' ? 'code' : 'email');
  }
  async function mount(container, settings) {
    if (!container || typeof container.addEventListener !== 'function') throw new TypeError('Customer auth requires a container.');
    unmount(container);
    var view = { container: container, options: settings || {}, stage: 'email', email: '', recovery: false, busy: false, error: '', notice: '', id: 'tm-auth-' + (++sequence) };
    views.set(container, view); container.innerHTML = '';
    try {
      var result = await init();
      if (views.get(container) !== view) return { enabled: false };
      if (!result.enabled || result.callback) { views.delete(container); return result; }
      var token = await getAccessToken();
      if (views.get(container) !== view) return { enabled: false };
      if (token && !session.passwordWarning) { await notify(view); return { enabled: true, authenticated: true, unmount: function () { unmount(container); } }; }
      if (token && session.passwordWarning) view.stage = 'password-warning';
      if (pendingSession) { view.stage = pendingStage; view.email = pendingSession.user.email; }
      view.submit = function (event) { submit(view, event); };
      view.click = function (event) { click(view, event); };
      function acceptCode(input) {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        if (view.stage === 'code' && !view.busy && input.value.length === 6) input.form.requestSubmit();
      }
      view.input = function (event) { if (event.target.name === 'code') acceptCode(event.target); };
      view.paste = function (event) { if (event.target.name === 'code') { var digits = event.clipboardData?.getData('text').replace(/\D/g, '').slice(0, 6); if (digits) { event.preventDefault(); event.target.value = digits; acceptCode(event.target); } } };
      container.addEventListener('submit', view.submit); container.addEventListener('click', view.click); container.addEventListener('input', view.input); container.addEventListener('paste', view.paste);
      view.timer = win.setInterval(function () { updateCooldown(view); }, 1000);
      render(view);
      return { enabled: true, unmount: function () { unmount(container); } };
    } catch (error) { report(view, error); if (views.get(container) === view) { views.delete(container); container.innerHTML = ''; } throw error; }
  }
  function close() {
    if (!activeDialog) return;
    var record = activeDialog;
    if (record.dialog.open) record.dialog.close();
    record.cleanup();
  }
  function open(settings) {
    settings = settings || {};
    if (activeDialog?.dialog.open) return activeDialog.promise;
    if (activeDialog) activeDialog.cleanup();
    var document = win.document, dialog = document.createElement('dialog');
    if (typeof dialog.showModal !== 'function') return Promise.reject(fail('disabled'));
    dialog.className = 'tm-auth-dialog'; dialog.dataset.customerAuthDialog = '';
    dialog.setAttribute('aria-label', 'Connexion ou inscription');
    var dismiss = document.createElement('button'); dismiss.type = 'button';
    dismiss.className = 'tm-auth-dialog__close'; dismiss.dataset.customerAuthClose = '';
    dismiss.setAttribute('aria-label', 'Fermer');
    dismiss.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
    var host = document.createElement('div'); host.dataset.customerAuthMount = '';
    dialog.append(dismiss, host); document.body.append(dialog);
    var record = { dialog: dialog, trigger: settings.trigger || document.activeElement, active: true, success: false, attempt: 0 };
    record.promise = new Promise(function (resolve) { record.resolve = resolve; });
    record.cleanup = function () {
      if (!record.active) return;
      record.active = false; record.attempt++;
      var view = views.get(host);
      unmount(host);
      // Cancel credentials that have not completed verification/registration.
      // Once authenticated, dismissing the card must not silently log out while
      // the caller is loading the verified account or its private projects.
      if (!record.success && !session && (view?.hasAuthenticationAttempt || pendingSession)) clearSession();
      dialog.remove(); document.documentElement.classList.remove('has-customer-auth-dialog');
      if (activeDialog === record) activeDialog = null;
      record.resolve(record.success);
      if (record.trigger?.isConnected) record.trigger.focus({ preventScroll: true });
    };
    async function load() {
      var attempt = ++record.attempt;
      host.innerHTML = '<div class="tm-auth-dialog__loading"><img class="tm-auth__logo" src="' + LOGO_URL + '" alt="Today Merch" width="120" height="42"><p role="status">Chargement de la connexion…</p></div>';
      try {
        var result = await mount(host, {
          returnTo: settings.returnTo, dialog: true, showSuccess: false,
          isCurrent: function () { return record.active && dialog.open && record.attempt === attempt; },
          onAuthenticated: async function (value) {
            if (!record.active || !dialog.open || record.attempt !== attempt) return;
            if (typeof settings.onAuthenticated === 'function') await settings.onAuthenticated(value);
            if (!record.active || !dialog.open || record.attempt !== attempt) return;
            record.success = true; dialog.close(); record.cleanup();
          },
          onError: function (error) { if (record.active && typeof settings.onError === 'function') settings.onError(error); }
        });
        if (!record.active || !dialog.open || record.attempt !== attempt) return;
        if (!result?.enabled) throw fail('disabled');
        if (document.activeElement === dialog || document.activeElement === dismiss) host.querySelector('input')?.focus({ preventScroll: true });
      } catch (_) {
        if (!record.active || !dialog.open || record.attempt !== attempt) return;
        host.innerHTML = '<div class="tm-auth tm-auth-dialog__unavailable"><img class="tm-auth__logo" src="' + LOGO_URL + '" alt="Today Merch" width="120" height="42"><h2>Connexion ou inscription</h2><p role="alert">La connexion n’est pas disponible pour le moment.</p><button type="button" class="tm-auth__button tm-auth__button--primary" data-customer-auth-retry>Réessayer</button></div>';
        host.querySelector('[data-customer-auth-retry]').addEventListener('click', load);
      }
    }
    dismiss.addEventListener('click', close);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('close', record.cleanup);
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = Array.from(dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]')).filter(function (node) { return node.getClientRects().length; });
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    activeDialog = record;
    dialog.showModal(); document.documentElement.classList.add('has-customer-auth-dialog');
    load();
    return record.promise;
  }
  function unmount(container) {
    if (!container) { Array.from(views.keys()).forEach(unmount); return; }
    var view = views.get(container); if (!view) return;
    views.delete(container); if (view.timer) win.clearInterval(view.timer);
    if (oauthPending?.owner === view) oauthPending.cancel();
    if (view.submit) container.removeEventListener('submit', view.submit);
    if (view.click) container.removeEventListener('click', view.click);
    if (view.input) container.removeEventListener('input', view.input);
    if (view.paste) container.removeEventListener('paste', view.paste);
    container.innerHTML = '';
  }
  return { init: init, readProjectBootstrap: readProjectBootstrap, open: open, close: close, mount: mount, unmount: unmount, getAccessToken: getAccessToken, invalidate: invalidate, logout: logout, sendEmailCode: sendEmailCode, verifyEmailCode: verifyEmailCode, signInWithPassword: signInWithPassword, completeRegistration: completeRegistration, updatePassword: updatePassword, signInWithGoogle: signInWithGoogle, signInWithMicrosoft: signInWithMicrosoft, create: createCustomerAuth };
});
